import script from "./SubsidiaryPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./SubsidiaryPopup.vue?vue&type=script&setup=true&lang=js"

import "./SubsidiaryPopup.vue?vue&type=style&index=0&id=0f8c516e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f8c516e"]])

export default __exports__